
export enum SharedReportSendTypeEnum {
    ALL = 'ALL',
    NEW_RECIPIENTS = 'NEW_RECIPIENTS',
    SPECIFIC_RECIPIENTS = 'SPECIFIC_RECIPIENTS'
}
export interface SendSharedReportApiModel {
    emailSubject: string;
    inviteMessage: string;
    mailingListIds: number[];
    recipientEmails: string[];
    sendType: SharedReportSendTypeEnum;
}
